export const ACTION_ADD_SITE_ARTICLES = 'ACTION_ADD_SITE_ARTICLES';

export const ACTION_CANCEL_SITE_ARTICLE__REQUEST = 'ACTION_CANCEL_SITE_ARTICLE__REQUEST';
export const ACTION_CANCEL_SITE_ARTICLE__SUCCESS = 'ACTION_CANCEL_SITE_ARTICLE__SUCCESS';
export const ACTION_CANCEL_SITE_ARTICLE__FAIL = 'ACTION_CANCEL_SITE_ARTICLE__FAIL';
